import React, { useMemo, useState, useEffect } from 'react'
import { styled, Stepper, Step, StepLabel, Typography, StepConnector, Box } from '@mui/material'
import { Tooltip } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'

import { useAlarm } from '../../../../core/utils/useAlarm'
import { APPLICATION_STATES } from '../../constants'
import { getCurrentWizardStep, getActiveWizardSteps, isProcessFinished } from './wizard.logics'
import { wizardStyles, stepStyles, stepIconStyles, stepConnectorStyles } from './wizard.styles'
import { CancelBtn, GetInstallerTxt } from '../buttons'
import { CAN_SELECT_INSTALLER } from './wizard.constants'

export const WizardComponent = withStyles(wizardStyles)(({ classes, steps, model }) => {
  const [step, setStep] = useState(getCurrentWizardStep(model))
  const { postAlarm } = useAlarm()
  const [alarm, setAlarm] = useState(false)

  const { formatMessage } = useIntl()

  useEffect(() => {
    if (alarm) {
      postAlarm('unkown_petition_state', 'state:' + alarm + ' , petition id:' + model['id'])
    }
  }, [alarm]) // eslint-disable-line

  useEffect(() => {
    const nextStep = getCurrentWizardStep(model)
    if (step !== nextStep) setStep(nextStep)
  }, [model['estado']]) // eslint-disable-line

  const canChangeInstaller =
    model['camino_solicitud'] === '01' &&
    (CAN_SELECT_INSTALLER[model.estado] ||
      (model?.estado === '37' && model.certificado_IRG3?.id === null)) &&
    (model['d_IRG3'] === null || model['certificado_IRG3_id'] === null) &&
    !model['gran_consumo_id']

  const StepViewFiltered = steps.find(({ id }) => id === step)
  if (!StepViewFiltered) {
    if (model.estado === APPLICATION_STATES.VALIDATION_PENDING.KEY) {
      return (
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Typography variant="h6" color="primary">
              {formatMessage({ id: 'Pendiente validar gestor' })}
            </Typography>
          </Box>
          <Box
            width="30%"
            display="flex"
            justifyContent={canChangeInstaller ? 'space-between' : 'flex-end'}
            alignItems="center"
          >
            {canChangeInstaller ? (
              <Box display="flex" height="100%" alignItems="center" flexGrow={1}>
                <GetInstallerTxt {...{ model }} />
              </Box>
            ) : null}
            <Box display="flex" height="auto" alignItems="center">
              <CancelBtn {...{ model }} />
            </Box>
          </Box>
        </Box>
      )
    } else {
      if (!alarm) setAlarm(model['estado'])
      return 'Petición en estado desconocido'
    }
  }
  const StepView = StepViewFiltered.component

  return useMemo(
    () =>
      StepView && (
        <div className={classes.wrapper}>
          <Stepper
            alternativeLabel
            activeStep={step}
            connector={<StepConnectorComponent />}
            className={classes.stepper}
          >
            {steps.map((item, i) => (
              <Step key={i} completed={item.id < step}>
                <StepComponent {...{ ...item, step, setStep, model }} />
              </Step>
            ))}
          </Stepper>
          <div className={classes.view}>
            <StepView {...{ step, setStep, model }} />
          </div>
        </div>
      ),
    [StepView, step, steps.length] // eslint-disable-line
  )
})

const StepComponent = withStyles(stepStyles)(({ classes, ...props }) => {
  const active = getActiveWizardSteps(props.model).some((stepId) => {
    return stepId === props.id
  })
  const completed = isProcessFinished(props.model) || props.id < getCurrentWizardStep(props.model)

  const tooltipClasses = styled((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.primary.main,
      width: 120,
    },
  }))

  return (
    <Tooltip
      arrow
      placement="top"
      classes={tooltipClasses()}
      title={props.tooltip}
      disableHoverListener={active || completed}
    >
      <StepLabel
        alternativeLabel
        className={active || completed ? classes.navegable : ''}
        StepIconComponent={() => <StepIconComponent active={active} completed={completed} />}
        onClick={() => (completed || active) && props.setStep(props.id)}
      >
        <div className={classes.label}>{props.label}</div>
      </StepLabel>
    </Tooltip>
  )
})

const StepIconComponent = withStyles(stepIconStyles)(({ classes, active, completed }) => {
  return (
    <div className={classes.root}>
      {active ? (
        <div className={classes.active} />
      ) : completed ? (
        <CheckIcon className={classes.completed} />
      ) : (
        <div className={classes.disabled} />
      )}
    </div>
  )
})

const StepConnectorComponent = withStyles(stepConnectorStyles)(StepConnector)
